// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3v0ET","additionalInfo":"AgreementModal_additionalInfo__ucGCL"};